import React, { Component } from "react";

import styles from "./About.css";

class Manifesto extends Component {
  render() {
    return (
      <div className={styles.aboutSections}>
        <div className={styles.sectionHeaders}>
          <h4>The Axios Manifesto</h4>
        </div>

        <div className={styles.aboutContent}>
          <p>
            All of us left cool, safe jobs to start a new company with this shared belief: Media is broken — and too often a scam.
          </p>

          <p>
            {"Stories are too long. Or too boring. Web sites are a maddening mess. Readers and advertisers alike are too often afterthoughts. They get duped by headlines that don't deliver and distracted by pop-up nonsense or unworthy clicks. Many now make money selling fake headlines, fake controversies and even fake news."}
          </p>

          <p>
            {"Can you imagine Ford being obsessed mainly with whether the engineers love the howl and design of the F-150 engine, instead of simply delivering an awesome truck people want to drive? Never. But that's what digital media companies too often do. They produce journalism the way journalists want to produce it. And they design their products to maximize short-term buzz or revenue — not deliver the best experience possible."}
          </p>

          <p>
            We are engineering Axios around a simple proposition: Deliver the cleanest, smartest, most efficient and trust-worthy experience for readers and advertisers alike.
          </p>

          <p>
            Our guiding principles include:
          </p>

          <p>
            <strong>Reader first</strong>
          </p>

          <p>
            {"The data on what news readers want is unmistakable: content they can trust — delivered way, way more efficiently. No bias. No nonsense. Every piece of content we produce will be broken and narrated with true expertise - and then summarized in one shareable element. You can decide whether to go deeper. Often, there's no need. We have one agenda: help people get smarter, faster. So we designed our content to move seamlessly from our platform to other ecosystems, including Facebook and Apple News, to meet readers on their terms, not ours."}
          </p>

          <p>
            <strong>Elegant efficiency</strong>
          </p>

          <p>
            Make reading, watching and listening as clean and reader-friendly as possible. This means killing everything from banner ads and pop-ups to topic pages and other web features designed for clicks, not usability. Our site eliminates traditional click-based pages AND allows you to view our content without leaving your stream of news. Our design guru, Alexis Lloyd, coined the term "elegant efficiency" to guide our every iteration.
          </p>

          <p>
            <strong>Smart, always</strong>
          </p>

          <p>
            {"Assume smart people want smart content — on our platform and beyond. Many don't want serious news and information. We focus only on those who do — and then resist all the traffic-based temptations to dumb things down. We have hired people with social media superpowers and asked them to quit using those powers to attract traffic for traffic’s sake, and instead use them as a force for good: Getting smart content in front of readers on our platforms and on Facebook, Apple News, LinkedIn and other social ecosystems."}
          </p>

          <p>
            <strong>{"Don't sell BS"}</strong>
          </p>

          <p>
            {"It's hard to argue with a straight face that newspaper ads, or banners, or expensive, glossy native advertising programs are the most effective means for communicating. We developed a lower-cost, more measurable and adjustable way for advertisers to do native advertising within our platform AND within our content on Facebook. We want to work with advertisers so they feel they get awesome, measurable value — and the respect and return they deserve."}
          </p>

          <p>
            <strong>Smart Brevity</strong>
          </p>

          <p>
            If you think about your evolving habits for consuming news and information, you realize you have less time, and a shorter attention span. Our content, our ads and our platforms are designed specifically to adjust to these new habits and demands. We aim to make the experience more substantive and meaningful — and therefore more valuable. When we pull this off, it will free people up to spend time on content truly WORTHY of their time, on our platform or elsewhere.
          </p>

          <p>
            <strong>Excellence always</strong>
          </p>

          <p>
            Media is a tough business. But it is a business, not a right, or charity or hobby. You distinguish yourself by delivering at a very high level on promises you make to news consumers, advertisers and subscribers. We believe life is simple: If we think big, deliver on our big promises, and show authentic appreciation for those who read and support us, we will be successful. So, thank you for reading this.
          </p>
        </div>
      </div>
    );
  }
}

export default Manifesto;



// WEBPACK FOOTER //
// ./src/about/components/About/Manifesto.js